// CharacteristicMapper.js

/**
 * Transform UI object → API payload
 * Replaces `value` with `characteristicValueSpecification`
 */
export function toApi(item) {
  const payload = { ...item };
  if (
    payload.valueType?.toUpperCase() === "ENUMERATION" ||
    payload.valueType?.toUpperCase() === "ENUM"
  ) {
    payload.characteristicValueSpecification = (
      payload.characteristicValueSpecification || []
    ).map((enumVal) => ({
      isDefault: !!enumVal.isDefault, // ensure boolean
      valueType: "ENUMERATION",
      value: enumVal.value,
      id: enumVal.id || undefined, // keep id if present
      //"@type": "EnumerationCharacteristicValueSpecification"
    }));
    delete payload.enumerationValues;
    delete payload.value;
  } else if (payload.value !== undefined) {
    // Non-enumeration case → keep as single object
    payload.characteristicValueSpecification = [
      {
        isDefault: true,
        valueType: payload.valueType?.toUpperCase(),
        value: payload.value,
        //"@type": `${capitalize(payload.valueType.toLowerCase())}CharacteristicValueSpecification`
      },
    ];
    delete payload.value;
  }

  return payload;
}

/**
 * Transform API object → UI object
 * Extracts `characteristicValueSpecification[0].value` into `value`
 */
export function fromApi(item) {
  const record = { ...item };

  if (
    record.characteristicValueSpecification &&
    record.characteristicValueSpecification.length > 0
  ) {
    const defaultOption = record.characteristicValueSpecification.find(
      (opt) => opt.isDefault,
    );

    record.value = defaultOption
      ? defaultOption.value
      : record.characteristicValueSpecification[0].value;
  }

  return record;
}

/**
 * Utility for capitalizing first letter
 */
function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function normalizeDateTime(value) {
  if (!value) return "";

  // If already in ISO with Z (UTC string)
  if (value.endsWith("Z")) {
    return new Date(value).toISOString().slice(0, 16);
  }

  // If format is already YYYY-MM-DDTHH:MM
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) {
    return value; // safe for datetime-local
  }

  // If format is YYYY-MM-DDTHH:MM:SS
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value)) {
    return value.slice(0, 16);
  }

  // Fallback
  return new Date(value).toISOString().slice(0, 16);
}
